module.exports = __webpack_public_path__ + "static/personal-finance-ui-57974022a56087347287d5a9f5d3ff71.png";